import Component from '../colorz/Component';

import device from '../colorz/utils/device';

module.exports = class FakeSelect extends Component {
  onInit( el, args) {
    // Initializations
    this.onToggle = this.onToggle.bind( this );
    this.onChoose  = this.onChoose.bind( this );
    this.otherTarget  = this.otherTarget.bind( this );

    this.el = el;
    this.button = this.el.querySelector('.js-dropdown-trigger');
    this.optionList  = this.el.querySelector('.js-dropdown-list');
    this.options = this.el.querySelectorAll('.js-dropdown-option');
    this.hiddenValue = this.el.querySelector('.js-dropdown-value');
    this.recrutement = this.el.querySelector('.js-dropdown-recrutement');
    this.inline = false;
    this.isOpen = false;
  }

  onReady() {
    this.button.addEventListener( device.pointerdown, this.onToggle );

    window.addEventListener( device.pointerdown, this.otherTarget );

    for(let i = 0; i < this.options.length; i++){
      this.options[i].addEventListener( device.pointerdown, this.onChoose );
    }

    if (this.el.classList.contains('related-instructions')) {
      this.instructions = this.el.querySelectorAll('.js-dropdown-instructions');
      this.hideInstructions();
    }

    if (this.el.classList.contains('fake-select--inline')){
      this.inline = true;
      this.label = this.el.querySelector('label').cloneNode(true);
    }
  }

  onToggle(e){
    if (this.isOpen){
      this.onClose();
    } else {
      this.onOpen();
    }
  }

  onOpen(){
    this.el.classList.add('is-open');
    this.isOpen = true;
  }

  onClose(){
    this.el.classList.remove('is-open');
    this.isOpen = false;
  }

  onChoose(e){
    this.button.innerHTML = e.target.innerHTML;
    this.hiddenValue.value = e.target.dataset.id;
    this.onToggle();
    this.showInstructions();
    this.inlineLabel();

    if ( this.recrutement.innerHTML == this.button.innerHTML ) {
      document.body.classList.add('shop-row-is-hidden');
    } else {
      document.body.classList.remove('shop-row-is-hidden');
    }
  }

  otherTarget(e){
    if (!this.el.contains(e.target) && e.target !== this.el ){
      this.onClose();
      e.stopPropagation();
    }
  }

  showInstructions(){
    if(!this.instructions) {
      return;
    }

    for (let i = 0; i < this.options.length; i++){
      if (this.button.innerHTML == this.options[i].innerHTML && !this.recrutement ){
        this.hideInstructions();
        this.instructions[i].classList.remove('hidden');
      }
    }
  }

  hideInstructions(){
    for (let i = 0; i < this.instructions.length; i++){
      this.instructions[i].classList.add('hidden');
    }
  }

  inlineLabel(){
    if (!this.inline) { return; }

    this.el.classList.add('has-value');
    this.el.insertBefore(this.label, this.button);
  }



}